import React, { useEffect, useRef, useState } from 'react';
import { signInWithPopup, GoogleAuthProvider, signOut } from 'firebase/auth';
import { auth, firestore } from '../config/firebaseConfig'; // Certifique-se que Firestore está configurado corretamente
import { collection, query, where, getDocs } from 'firebase/firestore'; // Funções Firestore
import './Login.css';

// O App mostra o Login enquanto não houver usuário OU tenantId. Com usuário autenticado
// (props.user), verifica se o e-mail está autorizado em algum inquilino, grava o tenantId
// e recarrega a página: vários módulos leem o tenantId do localStorage só ao carregar.
const Login = ({ user }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const verificadoRef = useRef(null);

  useEffect(() => {
    if (!user) {
      verificadoRef.current = null;
      return;
    }
    if (verificadoRef.current === user.uid) return; // evita verificar duas vezes
    verificadoRef.current = user.uid;

    const checkEmailAuthorization = async () => {
      setLoading(true);
      try {
        const inquilinosRef = collection(firestore, 'inquilinos');
        const q = query(inquilinosRef, where('emailsautorizados', 'array-contains', user.email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          // Usa o ID do documento como tenantId
          const tenantId = querySnapshot.docs[0].id;
          localStorage.setItem('tenantId', tenantId);
          window.location.reload();
          return; // mantém "Verificando..." até a página recarregar
        }
        console.log('E-mail não autorizado. Saindo...');
        setErrorMessage('Acesso negado.');
        await signOut(auth); // Sai se o e-mail não estiver autorizado
      } catch (error) {
        console.error('Erro ao verificar autorização do e-mail:', error);
        setErrorMessage('Erro ao verificar e-mail.');
        await signOut(auth).catch(() => {});
      }
      setLoading(false);
    };

    checkEmailAuthorization();
  }, [user]);

  const handleLogin = async () => {
    setLoading(true);
    const provider = new GoogleAuthProvider();
    try {
      // O App recebe o usuário pelo onAuthStateChanged e a verificação roda no efeito acima
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error('Erro na autenticação:', error);
      setErrorMessage('Erro na autenticação. Acesso negado.');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <img src="/logo-login.png" alt="Quizzap" className="logo" />
        </div>
        <h1>Bem-vindo</h1>
        <p>Faça login para acessar sua conta.</p>
        <button className="google-login" onClick={handleLogin} disabled={loading}>
          {loading ? 'Verificando...' : (
            <>
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" />
              Entrar com o Google
            </>
          )}
        </button>
        {errorMessage && (
          <div className="error-message">
            {errorMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
